// "Perfil" do menu ⋮ da conversa (pedido dele, 26/10/2026, com print: *"criar uma opcao aqui chamada
// Perfil, onde eu conseguisse preencher a AREA e a ORIGEM? O preenchimento teria o mesmo formato do
// Orcamento, ao enviar ao caixa"*). As duas pecas SAO as do Enviar ao Caixa: o listbox de etiquetas
// ([DA-723]) e o bloco "Como conheceu a loja?" ([DA-819]) — copia propria divergiria na primeira
// mudanca.
//
// ⛔ **So' preenche campo em BRANCO** (decisao dele: *"o sistema deve permitir modificar so' os campos
// em branco"*), pra todo perfil. Area em branco = o contato nao tem nenhuma etiqueta de area
// (`paraCampanha`) gravada; a oculta do rodizio nao conta, porque nao aparece como Area na lista.
// O que se marca AQUI segue trocavel por 15 minutos (a janela do servidor, [DA-722]) — o clique errado.
// A Origem daqui mora no CONTATO (migration 0345), nao na ficha — ver o `BlocoOrigemCliente`.
//
// ⛔ Grava no CLIQUE, as duas ([DA-707]): nao ha botao Salvar pra esquecer.
import { useCallback, useEffect, useState } from 'react';
import { Lock } from 'lucide-react';
import { Modal } from '../../../components/Modal';
import { api } from '../../../lib/api';
import { BlocoOrigemCliente } from '../../../components/orcamento/BlocoOrigemCliente';
import { ListboxEtiquetasVenda } from '../../../components/orcamento/ListboxEtiquetasVenda';
import {
  alternar as alternarEtiqueta, marcadasNaTela, ordenarParaOBalcao, type EstadoEtiquetas,
} from '../../../components/orcamento/etiquetas-do-balcao';
import { atendimentoApi } from '../lib/api';
import { useEtiquetas } from '../lib/etiquetas-context';
import type { Contato, Conversa } from '../lib/tipos';

interface Props {
  conversa: Conversa | null;
  onFechar: () => void;
  onContatoAtualizado: (c: Contato) => void;
  /** A Origem da lista sai do `GET /conversas` — quem hospeda rele a lista. */
  onOrigemGravada: () => void;
}

export function ModalPerfilContato({ conversa, onFechar, onContatoAtualizado, onOrigemGravada }: Props) {
  if (!conversa) return null;
  return (
    <ConteudoPerfil
      key={conversa.contato.id}
      conversa={conversa}
      onFechar={onFechar}
      onContatoAtualizado={onContatoAtualizado}
      onOrigemGravada={onOrigemGravada}
    />
  );
}

function ConteudoPerfil({ conversa, onFechar, onContatoAtualizado, onOrigemGravada }: Props & { conversa: Conversa }) {
  const ct = conversa.contato;
  const nome = [ct.nome, ct.sobrenome].filter(Boolean).join(' ') || ct.push_name || ct.telefone || ct.jid;
  const { paraCampanha, todas, atualizar } = useEtiquetas();
  const etiquetas = ordenarParaOBalcao(paraCampanha);
  // `null` = ainda lendo o que o contato ja tem.
  const [etq, setEtq] = useState<EstadoEtiquetas | null>(null);
  const [erroArea, setErroArea] = useState<string | null>(null);
  const [marcouOrigem, setMarcouOrigem] = useState(false);

  useEffect(() => {
    if (todas.length) return;
    atendimentoApi.listarEtiquetas().then(atualizar).catch(() => {});
  }, [todas.length, atualizar]);

  useEffect(() => {
    let vivo = true;
    api.get<{ etiqueta_ids?: number[] }>(`/api/contatos/identificar?contato_id=${ct.id}&inbox=atendimento`)
      .then((r) => { if (vivo) setEtq({ gravadas: r.etiqueta_ids ?? [], novas: [], remover: [] }); })
      .catch(() => { if (vivo) setErroArea('Nao consegui ler a area deste contato.'); });
    return () => { vivo = false; };
  }, [ct.id]);

  // Em branco = nenhuma etiqueta de AREA gravada antes desta tela (as ocultas nao entram).
  const areaPreenchida = !!etq && etq.gravadas.some((id) => paraCampanha.some((e) => e.id === id));

  // Mesmo gesto do `CampoEtiquetasVenda`: grava na hora e volta atras se o servidor recusar.
  // `ehAdmin` vai FALSO de proposito: aqui ninguem retira o que ja estava gravado.
  const alternar = useCallback((id: number) => {
    setEtq((antes) => {
      if (!antes) return antes;
      const depois = alternarEtiqueta(antes, id, false);
      if (depois === antes) return antes;
      const ficouMarcada = marcadasNaTela(depois).includes(id);
      api.post(`/api/contatos/${ct.id}/etiquetas/marcar`, ficouMarcada ? { acrescentar: [id] } : { remover: [id] })
        .then(() => {
          setErroArea(null);
          atendimentoApi.obterContato(ct.id).then(onContatoAtualizado).catch(() => {});
        })
        .catch((e: any) => {
          setErroArea(e?.corpo?.erro ?? 'Nao deu pra gravar a area.');
          setEtq(antes);
        });
      return depois;
    });
  }, [ct.id, onContatoAtualizado]);

  return (
    <Modal
      aberto
      onFechar={onFechar}
      titulo={`Perfil — ${nome}`}
      largura={760}
      // Unica saida da janela: `btn-primario`, porque o secundario sozinho some no rodape ([DA-667]).
      rodape={<button type="button" className="btn-primario" onClick={onFechar}>Fechar</button>}
    >
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', gap: 12, alignItems: 'start' }}>
        <div>
          {etq === null ? (
            <div className="text-[12px]" style={{ color: 'var(--text-muted)' }}>{erroArea ?? 'carregando a area...'}</div>
          ) : (
            <>
              <ListboxEtiquetasVenda
                etiquetas={etiquetas}
                estado={etq}
                onAlternar={alternar}
                ehAdmin={false}
                desabilitado={areaPreenchida}
                semAvisoTravadas
              />
              {areaPreenchida && (
                <div className="text-[11px] mt-1.5 flex items-start gap-1.5" style={{ color: 'var(--text-muted)' }}>
                  <Lock size={10} className="flex-shrink-0 mt-[2px]" />
                  <span>Area ja preenchida. Aqui so' se preenche o que esta em branco — o administrador corrige pelo painel do contato.</span>
                </div>
              )}
              {erroArea && <div className="text-[11px] text-red-700 mt-1">{erroArea}</div>}
            </>
          )}
        </div>
        <div>
          <BlocoOrigemCliente
            orcamentoId={null}
            clienteId={0}
            contatoId={ct.id}
            marcouAqui={marcouOrigem}
            onMarcou={() => { setMarcouOrigem(true); onOrigemGravada(); }}
          />
        </div>
      </div>
    </Modal>
  );
}
